import { gql } from '@src/lib/gql'

export const INVITE_TO_BOARD_OPEN_SEATS = gql`
  query InviteToBoardOpenSeats {
    advisorEngagements(role: "FOUNDER", statusKeys: ["draft", "searching"], pageSize: 50) {
      items {
        id
        advisorEngagementId
        categoryKey
        category {
          id
          key
          title
        }
        status {
          id
          key
          title
        }
      }
    }
  }
`
